import { css, keyframes } from 'styled-components'
import tw, { styled } from 'twin.macro'

const overlayIntro = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const overlayOutro = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`

const contentIntro = keyframes`
  from {
    ${tw`opacity-0 scale-95`}
  }

  to {
    ${tw`opacity-100 scale-100`}
  }
`

const contentOutro = keyframes`
  from {
    ${tw`opacity-100 scale-100`}
  }

  to {
    ${tw`opacity-0 scale-95`}
  }
`

export const DialogOverlayStyles = css`
  ${tw`fixed inset-0 bg-inverted-neutral bg-opacity-50`}

  @media (prefers-reduced-motion: no-preference) {
    ${tw`opacity-0`}

    &[data-state='open'] {
      animation: ${overlayIntro} 300ms ease-out forwards;
    }

    &[data-state='closed'] {
      animation: ${overlayOutro} 300ms ease-in forwards;
    }
  }
`

export const DialogContentStyles = css``

/** This aligner component exists to align the dialog box with flex
 * instead of letting it position itself via top/left 50% + transform -50%,
 * which would prevent us from animating the transform property
 * */
export const DialogAligner = tw.div`
  fixed
  inset-0
  flex
  items-center
  justify-center
  pointer-events-none
`

// ref: https://styled-components.com/docs/api#transient-props
export const DialogBox = styled.div`
  ${tw`
    w-full
    p-10
    bg-default-subdued
    text-left
    shadow-xl
    outline-none
    pointer-events-auto
    sm:px-8
  `}

  &[data-fullscreen='none'] {
    ${tw`
      h-auto
      max-w-xs
      rounded-lg
      sm:max-w-md
      md:max-w-xl
    `}
  }

  &[data-fullscreen='always'] {
    ${tw`h-full`}
  }

  &[data-fullscreen='mobile-only'] {
    ${tw`
      h-full
      sm:max-w-md
      sm:h-auto
      sm:rounded-lg
      md:max-w-xl
    `}
  }

  @media (max-height: 719px) {
    max-height: 90vh;
    overflow: auto;
  }

  @media (prefers-reduced-motion: no-preference) {
    [role='dialog'][data-state='open'] &,
    [role='alertdialog'][data-state='open'] & {
      animation: ${contentIntro} 300ms ease-out forwards;
    }

    [role='dialog'][data-state='closed'] &,
    [role='alertdialog'][data-state='closed'] & {
      animation: ${contentOutro} 200ms ease-in forwards;
    }
  }
`
